module.exports = __webpack_public_path__ + "img/step-help2.61ab5297.png";